<template>
	<a-drawer :title="theTitle"  :visible="showFlag" width="480" @close="closeView" :destroyOnClose="true">
		<vxe-table  align="center" :data="list"  border max-height="600" ref="mTable" show-overflow="title" size="mini"
						  :loading="loading" row-id="id" >
				<vxe-table-column type="seq" width="60"></vxe-table-column>
				<vxe-table-column title="抄表读数" field="read_data" ></vxe-table-column>
				<vxe-table-column title="抄表时间" field="read_time" width="160"></vxe-table-column>
		</vxe-table>
	</a-drawer>
</template>

<script>
	export default {
		data(){
			return {
				showFlag:false,
				theMeterAddr:'',
				loading:false,
			}
		},
		methods: {
			showView(meterAddr){
				this.showFlag = true;
				this.theMeterAddr = meterAddr;
				this.queryData();
			},
			closeView() {
				this.showFlag = false;
			},
			queryData(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.FG_METER_HISTORY_DATA);
				let param = {meterAddr:this.theMeterAddr};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
		computed: {
			theTitle() {
				return '历史详情-'+this.theMeterAddr; 
			}
		},
	}
</script>

<style>
</style>
